import  {  Injectable  }  from  '@angular/core';
import  {  CoreService  }  from  '../../../../core/core.service';
import  {  Observable  }  from  'rxjs/Rx';

@Injectable()
export class FranchiseService {

    constructor(private coreService: CoreService) { }


    SaveVideoFranchise(franchise) {
        return this.coreService.post('Forms/SaveVideoFranchise/', franchise);

    }

    SaveVideoProvider(provider) {
        return this.coreService.post('Forms/SaveVideoProvider/', provider);

    }
    GetStates(provider) {
        return this.coreService.post('Forms/GetStates/', '');
    }
    GetCounty(provider) {
        return this.coreService.post('Forms/GetCounty/', '');
    }

}

